if (!customElements.get("customer-reviews-slider")) {
  class CustomerReviewsSlider extends HTMLElement {
    constructor() {
      super();

      this.swiper = null;

      this.handleMouseEnter =
        this.handleMouseEnter.bind(this);

      this.handleMouseLeave =
        this.handleMouseLeave.bind(this);
    }

    connectedCallback() {
      if (this.swiper) return;

      this.slider = this.querySelector(
        "[data-customer-reviews-swiper]"
      );

      this.previousButton = this.querySelector(
        "[data-customer-reviews-prev]"
      );

      this.nextButton = this.querySelector(
        "[data-customer-reviews-next]"
      );

      this.pagination = this.querySelector(
        "[data-customer-reviews-pagination]"
      );

      this.progressBar = this.querySelector(
        "[data-customer-reviews-progress]"
      );

      if (!this.slider) return;

      if (typeof window.Swiper !== "function") {
        console.warn(
          "Customer reviews slider: Swiper is not available."
        );

        return;
      }

      this.initializeSlider();
    }

    initializeSlider() {
      const slideCount = this.slider.querySelectorAll(
        ".swiper-slide"
      ).length;

      const slidesDesktop = Number(
        this.dataset.slidesDesktop || 3.2
      );

      const slidesTablet = Number(
        this.dataset.slidesTablet || 2.2
      );

      const slidesMobile = Number(
        this.dataset.slidesMobile || 1.1
      );

      const gapDesktop = Number(
        this.dataset.gapDesktop || 18
      );

      const gapMobile = Number(
        this.dataset.gapMobile || 12
      );

      const sliderSpeed = Number(
        this.dataset.sliderSpeed || 500
      );

      const enableLoop =
        this.dataset.enableLoop === "true";

      const enableDrag =
        this.dataset.enableDrag === "true";

      const autoRotate =
        this.dataset.autoRotate === "true";

      const autoRotateDelay = Number(
        this.dataset.autoRotateDelay || 5000
      );

      const options = {
        slidesPerView: slidesMobile,
        slidesPerGroup: 1,
        spaceBetween: gapMobile,
        speed: sliderSpeed,
        loop:
          enableLoop &&
          slideCount > Math.ceil(slidesDesktop),

        grabCursor: enableDrag,
        allowTouchMove: enableDrag,
        simulateTouch: enableDrag,

        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        mousewheel: {
          forceToAxis: true
        },

        navigation: {
          nextEl: this.nextButton,
          prevEl: this.previousButton
        },

        breakpoints: {
          750: {
            slidesPerView: slidesTablet,
            spaceBetween: gapDesktop
          },

          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop
          }
        }
      };

      if (this.pagination) {
        options.pagination = {
          el: this.pagination,
          clickable: true
        };
      }

      if (this.progressBar) {
        options.scrollbar = {
          el: this.progressBar,
          draggable: true,
          hide: false
        };
      }

      if (autoRotate && slideCount > 1) {
        options.autoplay = {
          delay: autoRotateDelay,
          disableOnInteraction: false
        };
      }

      this.swiper = new Swiper(
        this.slider,
        options
      );

      if (
        autoRotate &&
        this.dataset.pauseOnHover === "true"
      ) {
        this.addEventListener(
          "mouseenter",
          this.handleMouseEnter
        );

        this.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        );
      }
    }

    handleMouseEnter() {
      this.swiper?.autoplay?.pause();
    }

    handleMouseLeave() {
      this.swiper?.autoplay?.resume();
    }

    disconnectedCallback() {
      this.removeEventListener(
        "mouseenter",
        this.handleMouseEnter
      );

      this.removeEventListener(
        "mouseleave",
        this.handleMouseLeave
      );

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define(
    "customer-reviews-slider",
    CustomerReviewsSlider
  );
}